import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router)

export default new Router({
	mode:'history',
	base:'/',
	routes: [
		{
			path: '/login',
			name: '登录页',
            component: () => import('@/components/login')
		},
		{
			path: '/',
			name: '首页',
            component: () => import('@/components/fortune'),
			children:[
				{
					path: '/', 
					component: () => import('@/components/index'),
					name: '首页内容'
				},
				{
					path: '/', 
					component: () => import('@/components/web/index'),
					name: '内容框架',
					children:[
						{
							path: '/view/gqxx/:id', 
							component: () => import('@/components/web/info_gqxx'),
							name: '新闻详情'
						},
						{
							path: '/view/web/:code', 
							component: () => import('@/components/web/info'),
							name: '内容详情'
						},
						{
							path: '/view/server/:id', 
							component: () => import('@/components/web/info_server'),
							name: '图文详情'
						},
						{
							path: '/gqxx/:code', 
							component: () => import('@/components/web/gqxx'),
							name: '新闻记录'
						},
						{
							path: '/server/:code', 
							component: () => import('@/components/web/server'),
							name: '图文记录'
						}
					]
				},
				{
					path: '/web/:code', 
					component: () => import('@/components/web/web'),
					name: '留言'
				}
			]
		},
		{
			path: '/manage',
			name: '后台主页',
            component: () => import('@/components/manage'),
			children:[
				{
					path: '/manage', 
					component: () => import('@/components/home'),
					name: '后台首页'
				},
				{
					path: '/adminManage', 
					component: () => import('@/components/system/admin'),
					name: '管理员管理'
				},
				{
					path: '/authManage',
					component: () => import('@/components/system/auth'),
					name: '权限规则管理'
				 },
				{
					path: '/roleManage',
					component: () => import('@/components/system/role'),
					name: '角色管理'
				 },
				 {
					path: '/LogManage',
					component: () => import('@/components/system/log'),
					name: '系统日志'
				},
				{
					path: '/dictionaryManage',
					component: () => import('@/components/system/dictionary'),
					name: '字典管理'
				},
				{
					path: '/menusManage',
					component: () => import('@/components/system/menus'),
					name: '菜单管理'
				},
				{
					path: '/noticeManage',
					component: () => import('@/components/system/notice'),
					name: '系统公告'
				},
				{
					path: '/bannerManage',
					component: () => import('@/components/system/banner'),
					name: '系统广告'
				},
				{
					path: '/docxManage',
					component: () => import('@/components/system/docx'),
					name: '文档资料管理'
				},

				{
					path: '/site_manage',
					component: () => import('@/components/business/site/config'),
					name: '站点配置'
				},
				{
					path: '/navcontent_manage',
					component: () => import('@/components/business/navcontent/manage'),
					name: '站点内容配置'
				},
				{
					path: '/news_manage',
					component: () => import('@/components/business/news/manage'),
					name: '新闻内容管理'
				},
				{
					path: '/gphoto_manage',
					component: () => import('@/components/business/news/gphoto'),
					name: '图片新闻管理'
				},
				{
					path: '/links_manage',
					component: () => import('@/components/business/links/manage'),
					name: '友情链接管理'
				},
				{
					path: '/leaveword_manage',
					component: () => import('@/components/business/leaveword/manage'),
					name: '留言管理'
				},
				{
					path: '/wxvideo_manage',
					component: () => import('@/components/business/wxvideo/manage'),
					name: '微信视频管理'
				},
			]
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js